import { memo, ReactElement, useMemo } from 'react';
import { Breadcrumbs as BreadcrumbsMaterial, Theme, Typography } from '@mui/material';
import { generatePath, Link, useParams } from 'react-router-dom';
import { ClassNameMap, makeStyles, createStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => {
  const primaryColor = theme.palette.cdmBrand.main;

  return createStyles({
    link: {
      color: primaryColor,
      '&:hover': {
        opacity: 0.8,
      },
    },
  });
});

export interface BreadcrumbItem {
  path?: string;
  name: string;
}

interface BreadcrumbsProps {
  items: Array<BreadcrumbItem>;
  base?: string;
}

const BreadcrumbsComponent = ({ items }: BreadcrumbsProps): ReactElement => {
  const classes: ClassNameMap<string> = useStyles();
  const params = useParams();
  const crumbs = useMemo(
    () =>
      items
        .filter(({ name }: BreadcrumbItem) => {
          return !!name;
        })
        .map((item) => ({
          ...item,
          path: generatePath(item.path || '', params),
        })), // generats path through parameters with equal names
    [items, params]
  );

  return (
    <BreadcrumbsMaterial separator="›" aria-label="breadcrumb">
      {crumbs.map(({ name, path }: BreadcrumbItem, key: number) =>
        key + 1 === crumbs.length ? (
          <Typography key={key} className="notranslate">
            {name}
          </Typography>
        ) : (
          <Link
            key={key}
            to={path === '/' ? path : `/${path}`}
            className={`${classes.link} notranslate`}
          >
            {name}
          </Link>
        )
      )}
    </BreadcrumbsMaterial>
  );
};

BreadcrumbsComponent.displayName = 'Breadcrumbs';

const Breadcrumbs = memo(BreadcrumbsComponent);

export default Breadcrumbs as typeof BreadcrumbsComponent;
